<template>
<v-list-item  style="cursor: pointer;">
  <v-list-item-avatar @click="$emit('profile')">
    <img :src="profile.avatar">
  </v-list-item-avatar>
  <v-list-item-content @click="$emit('profile')">
    <v-list-item-title class="pl-1 grey--text text--darken-3">{{profile.name}}</v-list-item-title>
    <v-list-item-subtitle class="caption pl-1" v-if="profile.rating">
      <v-icon style="font-size: 12px; vertical-align: baseline;" class="mr-1" color="grey darken-1">fas fa-star</v-icon>
      <span class="body-1 grey--text text--darken-2">{{ profile.rating }}</span>
    </v-list-item-subtitle>
    <v-list-item-subtitle class="caption pl-1" v-else>Not enough ratings yet.</v-list-item-subtitle>
  </v-list-item-content>
  <v-list-item-action v-if="chat || pay">
    <v-icon v-if="chat && !pay" :color="profile.active ? 'teal' : 'grey'" @click="$emit('message')">chat_bubble</v-icon>
      <div v-if="profile.status === 'Paid'">
        <span class="caption grey--text text--darken-3">Paid </span>
        <v-icon small color="green" class="font-weight-bold">check</v-icon>
      </div>
      <v-btn v-if="(pay && !chat) && (profile.status === 'Completed') && profile.expenses||(payShift&&!chat)" @click="$emit('pay')">
        <v-icon color="green">attach_money</v-icon>
        <div class="mr-2">
          PAY NOW
        </div>
      </v-btn>
  </v-list-item-action>
</v-list-item>
</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
export default {
  props: ['profile', 'chat', 'pay', 'jobKey'],
  data () {
    return {
      sub: ''
    }
  },

  computed: {
    ...mapState(['userProfile', 'currentUser']),
    payShift () {
      var shouldPay = Object.values((this.profile || {}).jobLog || {}).filter(k => k.status === 'pending')
      return shouldPay.length > 0
    }
  },
  methods: {},
  filters: {
    acceptedApplicants (val) {
      return Object.keys(val).reduce(function (acc, key) {
        if (val[key] === 'Applied') {
          return acc + 1
        }
        return acc
      }, 0)
    },
    formatImgURL (val) {
      return '@/assets/Agriculture.svg'
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    trimLength (val) {
      return `${val.substring(0, 8)}...`
    }
  }
}
</script>
